import React from "react";
import { Modal, Button, Spin } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { Customer } from "../../Types";

interface LoyaltyData {
  points_balance: number;
  earn_ratio: number;
  point_value_lkr: number;
  total_earned: number;
  total_redeemed: number;
  balance_value_lkr: number;
  enabled: boolean;
}

interface Props {
  customer: Customer | null;
  loyaltyData?: LoyaltyData | null;
  loading: boolean;
  sending: boolean;
  onClose: () => void;
  onSendCard: (customer: Customer) => void;
}

export const LoyaltyModal: React.FC<Props> = ({
  customer,
  loyaltyData,
  loading,
  sending,
  onClose,
  onSendCard,
}) => (
  <Modal
    title={customer ? `${customer.name} - Loyalty` : "Loyalty"}
    open={!!customer}
    onCancel={onClose}
    footer={[
      <Button key="close" onClick={onClose}>
        Close
      </Button>,
      <Button
        key="send"
        type="primary"
        icon={<SendOutlined />}
        loading={sending}
        onClick={() => customer && onSendCard(customer)}
      >
        Send WhatsApp Card
      </Button>,
    ]}
  >
    <Spin spinning={loading}>
      {loyaltyData ? (
        <div className="py-2 space-y-3">
          <div className="flex justify-between items-center bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
            <span className="text-sm text-gray-600">Available Balance</span>
            <span className="text-xl font-bold text-amber-600">
              {loyaltyData.points_balance.toLocaleString()} pts
            </span>
          </div>
          <div className="grid grid-cols-2 gap-3 text-center">
            <div className="bg-gray-50 rounded-lg px-3 py-2">
              <p className="text-[11px] text-gray-400 m-0">Earn Ratio</p>
              <p className="text-sm font-semibold text-gray-700 m-0">
                LKR {loyaltyData.earn_ratio} = 1 pt
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg px-3 py-2">
              <p className="text-[11px] text-gray-400 m-0">Point Value</p>
              <p className="text-sm font-semibold text-gray-700 m-0">
                LKR {Number(loyaltyData.point_value_lkr).toFixed(2)}
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg px-3 py-2">
              <p className="text-[11px] text-gray-400 m-0">Total Earned</p>
              <p className="text-sm font-semibold text-green-600 m-0">
                {loyaltyData.total_earned.toLocaleString()}
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg px-3 py-2">
              <p className="text-[11px] text-gray-400 m-0">Total Redeemed</p>
              <p className="text-sm font-semibold text-rose-500 m-0">
                {loyaltyData.total_redeemed.toLocaleString()}
              </p>
            </div>
          </div>
          {loyaltyData.enabled ? (
            <p className="text-xs text-gray-400 m-0">
              Balance value: LKR{" "}
              {Number(loyaltyData.balance_value_lkr).toLocaleString(undefined, {
                minimumFractionDigits: 2,
              })}
            </p>
          ) : (
            <p className="text-xs text-amber-500 m-0">
              Loyalty program is currently disabled for this store.
            </p>
          )}
        </div>
      ) : (
        !loading && (
          <p className="text-center text-gray-400 py-4">
            No loyalty data for this customer yet.
          </p>
        )
      )}
    </Spin>
  </Modal>
);
